var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkSentArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 610,
    height: 610,
    viewBox: "0 0 610 610",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link_sent_art",
    transform: "translate(-335 -235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail-rafiki_1_",
    "data-name": "Mail-rafiki (1)",
    transform: "translate(278.89 183.331)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-34",
    transform: "translate(113.706 98.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M510.663,216.692c-29.29-26.873-60.217,8.219-91.835,8.659-37.911.534-49.74-15.715-73.7-41.347-35.347-37.827-71.983-86.8-129.2-85.3C62.279,102.725,66.841,286.295,150.417,371.408c54.223,55.192,113.5,40.294,182.066,47.334,61.821,6.286,159.3,56.936,220.448,23.337,54.459-29.937,38.965-109.237-14.158-131.144-17.193-7.088-27.277-23.431-25-42.038C515.9,251.407,526.362,231.072,510.663,216.692Z",
    transform: "translate(-92.724 -98.669)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M510.663,216.692c-29.29-26.873-60.217,8.219-91.835,8.659-37.911.534-49.74-15.715-73.7-41.347-35.347-37.827-71.983-86.8-129.2-85.3C62.279,102.725,66.841,286.295,150.417,371.408c54.223,55.192,113.5,40.294,182.066,47.334,61.821,6.286,159.3,56.936,220.448,23.337,54.459-29.937,38.965-109.237-14.158-131.144-17.193-7.088-27.277-23.431-25-42.038C515.9,251.407,526.362,231.072,510.663,216.692Z",
    transform: "translate(-92.724 -98.669)",
    fill: "#fff",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-34",
    transform: "translate(56.11 579.95)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-34",
    cx: 305,
    cy: 17.79,
    rx: 305,
    ry: 17.79,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mailbox--inject-34",
    transform: "translate(81.562 289.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M7.047,0H56.614a7.044,7.044,0,0,1,7.047,7.04V93.333H0V7.025A7.044,7.044,0,0,1,7.047,0Z",
    transform: "translate(183.702 307.895) rotate(180)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M212.256,356.85H148.61V394.3l63.646-13.782Z",
    transform: "translate(-28.554 -142.288)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M206.48,317.387a89.664,89.664,0,0,1,179.329,0v113.15H206.48Z",
    transform: "translate(4.608 -216.038)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M206.48,317.387a89.664,89.664,0,0,1,179.329,0v113.15H206.48Z",
    transform: "translate(4.608 -216.038)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M72.29,317.377v102.07a11.163,11.163,0,0,0,11.184,11.158h199.9V317.377A89.621,89.621,0,0,1,373.043,227.8H161.954A89.621,89.621,0,0,0,72.29,317.377Z",
    transform: "translate(-72.29 -216.043)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_859",
    "data-name": "Rectangle 859",
    width: 211.089,
    height: 31.43,
    transform: "translate(211.104 181.151) rotate(180)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 211.089,
    height: 31.43,
    transform: "translate(211.104 139.962) rotate(180)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_861",
    "data-name": "Rectangle 861",
    width: 25.688,
    height: 1.572,
    transform: "translate(198.63 6.256)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    width: 13.811,
    height: 1.572,
    transform: "translate(171.353 6.256)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M155.6,351.1V223.809a3.491,3.491,0,0,0-4.074-3.442l-44.47,7.308v18.434h33.994V350.82a16.686,16.686,0,1,0,14.551.3Z",
    transform: "translate(-52.365 -220.319)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M219.237,369.606H449.281a6.368,6.368,0,0,0,6.387-6.286h0a6.383,6.383,0,0,0-6.387-6.38H206.48A12.751,12.751,0,0,0,219.237,369.606Z",
    transform: "translate(4.609 -142.237)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M219.237,369.606h94.006a6.368,6.368,0,0,0,6.387-6.286h0a6.383,6.383,0,0,0-6.387-6.38H206.48A12.751,12.751,0,0,0,219.237,369.606Z",
    transform: "translate(4.609 -142.237)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-34",
    transform: "translate(327.211 115.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M360.652,418.576l-13.308.11L343.71,387.9l13.324-.11Z",
    transform: "translate(-162.399 49.88)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M343.71,387.91l1.872,15.872,13.324-.126L357.034,387.8Z",
    transform: "translate(-162.399 49.886)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M434.2,395.623l-11.452,6.789L404.11,377.629l11.452-6.789Z",
    transform: "translate(-127.787 40.193)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M404.12,377.629l9.6,12.776,11.468-6.789-9.611-12.776Z",
    transform: "translate(-127.781 40.193)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M356.267,406.516l14.551-.126a1.258,1.258,0,0,1,1.2.9l3.524,11.8a1.808,1.808,0,0,1-1.746,2.373c-5.254,0-12.852-.283-19.459-.22-7.708,0-11.137.55-20.182.629-5.474,0-7.393-5.469-5.144-5.987,10.241-2.357,15.542-2.672,24.131-8.3a5.856,5.856,0,0,1,3.13-1.069Z",
    transform: "translate(-171.354 60.51)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M343.921,409.216a21.089,21.089,0,0,0,4.263-.519.283.283,0,0,0,.236-.267.314.314,0,0,0-.173-.314c-.629-.314-6.292-2.986-7.755-2.043a.958.958,0,0,0-.44.849,1.869,1.869,0,0,0,.708,1.572,5.133,5.133,0,0,0,3.162.723Zm3.146-.943c-2.879.5-5.065.393-5.946-.314a1.273,1.273,0,0,1-.472-1.037.346.346,0,0,1,.142-.314c.865-.534,4.027.6,6.308,1.634Z",
    transform: "translate(-164.498 60.215)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M347.018,409.815a.442.442,0,0,0,.189,0,.283.283,0,0,0,.11-.3c0-.251-1.038-5.972-4.216-5.61-.834.094-1.07.5-1.117.849-.22,1.572,3.146,4.369,4.908,5.092Zm-3.65-5.359c1.9,0,2.863,3.143,3.146,4.463-1.746-.99-4.09-3.253-3.964-4.133,0,0,0-.267.566-.33Z",
    transform: "translate(-163.395 59.081)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M382.446,174.916c-1.746,10.1-3.964,19.8-6.654,29.592q-2.014,7.323-4.452,14.6c-.849,2.436-1.652,4.856-2.611,7.276-.456,1.21-.912,2.42-1.431,3.63l-.739,1.823-.378.9-.2.487-.283.613a43.4,43.4,0,0,1-4.719,7.858c-1.573,2.216-3.288,4.259-4.971,6.286-3.366,3.96-6.874,7.638-10.429,11.252A289.721,289.721,0,0,1,323.2,279.454L316.11,272.4c6.056-7.685,12.16-15.448,18.059-23.133,2.942-3.835,5.8-7.732,8.479-11.582,1.337-1.917,2.611-3.85,3.728-5.736a31.416,31.416,0,0,0,2.58-5.06c.094-.189.315-.943.488-1.446l.535-1.666c.378-1.084.708-2.216,1.038-3.347.676-2.247,1.306-4.542,1.951-6.82,1.227-4.6,2.375-9.256,3.492-13.939,2.171-9.429,4.263-18.953,6.151-28.287Z",
    transform: "translate(-178.216 -73.803)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M374.874,181.716c-.8,15.181-8.164,36.491-8.164,36.491l-20.67-7.858-8.51-3.143a119.859,119.859,0,0,1,7.11-29.372c6.292-16.187,20.874-20.131,28.315-8.219C374.686,172.3,375.142,176.672,374.874,181.716Z",
    transform: "translate(-165.941 -78.765)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M371.774,175.618c-.8,15.181-8.164,36.491-8.164,36.491l-20.67-7.858a116.213,116.213,0,0,1,4.814-15.747C352.913,175.021,363.925,170.039,371.774,175.618Z",
    transform: "translate(-162.841 -72.667)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M323.392,234.71,309.36,237l-.11,13.751s13.465-1.886,18.735-8.329Z",
    transform: "translate(-182.147 -37.609)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M301.06,244.138l.3,9.036,12.584-3.253.094-13.751Z",
    transform: "translate(-186.84 -36.774)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M361.59,236.49S341.6,309.2,336.3,349.907c-5.506,42.337,7.488,133.124,7.488,133.124l24.052-.519s1.809-92.547,9.674-134.177c8.62-45.37,25.043-112.725,25.043-112.725Z",
    transform: "translate(-167.428 -37.094)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M368.79,396.645l-28.284.566-2.076-9.382,30-.079Z",
    transform: "translate(-165.425 49.857)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M368.79,396.645l-28.284.566-2.076-9.382,30-.079Z",
    transform: "translate(-165.425 49.857)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M422.42,392.86l12.506-7.418a1.259,1.259,0,0,1,1.573.173l8.982,8.423a1.806,1.806,0,0,1-.315,2.939c-4.562,2.609-11.247,6.286-16.926,9.571-6.623,3.945-9.438,6.082-17.131,10.686-4.719,2.8-9.139-.99-7.456-2.577,7.661-7.2,12.081-10.136,16.674-19.3A5.769,5.769,0,0,1,422.42,392.86Z",
    transform: "translate(-128.258 48.425)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M414.89,394.288a22.883,22.883,0,0,0,3.429-2.577.345.345,0,0,0,.079-.361.3.3,0,0,0-.315-.189c-.708,0-6.89.534-7.724,2.137a.911.911,0,0,0,0,.959,1.872,1.872,0,0,0,1.368.959A5.164,5.164,0,0,0,414.89,394.288Zm2.281-2.42c-2.234,1.886-4.184,2.892-5.3,2.719a1.274,1.274,0,0,1-.928-.644.345.345,0,0,1,0-.361C411.445,392.732,414.67,392.119,417.171,391.868Z",
    transform: "translate(-124.284 51.805)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M417.873,392.878a.425.425,0,0,0,.126-.157.282.282,0,0,0,0-.314c-.157-.189-3.917-4.715-6.465-2.734-.676.5-.676.99-.551,1.3.566,1.4,4.971,2.169,6.811,1.949Zm-5.852-2.8c1.652-.959,4.043,1.242,5.018,2.247-2.029,0-5.175-.754-5.521-1.572,0,0-.094-.236.33-.55Z",
    transform: "translate(-123.885 50.67)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M367.69,236.207s0,71.441,1.872,112.442c1.919,42.651,55.246,116.041,55.246,116.041l20.528-12.572s-36.023-69.838-35.472-112.191c.6-46.187,4.184-104.758,4.184-104.758Z",
    transform: "translate(-148.658 -37.346)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M429.079,376.279,406.349,390.14,400.67,384.5l25.012-16.658Z",
    transform: "translate(-129.758 38.478)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M429.079,376.279,406.349,390.14,400.67,384.5l25.012-16.658Z",
    transform: "translate(-129.758 38.478)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M353.068,164.781s-14.865,40.514,1.652,115l71.228-1.572c.252-10.922-7.755-64.055,1.7-115.743a183.572,183.572,0,0,0-23.973-2.4,257.429,257.429,0,0,0-30.266.644,133.071,133.071,0,0,0-20.34,4.07Z",
    transform: "translate(-160.557 -80.373)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M390.608,138.33c-1.7,9.759-3.225,27.643,3.728,33.992,0,0-2.454,9.979-20.544,10.309-14.456.267-9.721-9.665-9.721-9.665,10.807-2.829,10.351-10.875,8.29-18.387Z",
    transform: "translate(-151.157 -92.692)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M379.871,142.54l-10.791,9.618a30.794,30.794,0,0,1,1.038,5.343c4.137-.676,9.753-5.359,10.1-9.712A14.476,14.476,0,0,0,379.871,142.54Z",
    transform: "translate(-147.861 -90.286)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M388.14,177.93l11.877,8.549c-.519,9.1-.676,17.947-.6,26.244C392.136,205.4,388.062,191.932,388.14,177.93Z",
    transform: "translate(-136.939 -70.06)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M388.439,156.87s-3.414,8.2-19.349,15.181a19.841,19.841,0,0,1,11.2,11.472s11.594-11,14.692-22Z",
    transform: "translate(-147.855 -82.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M362.3,179.718s4.876-7.072,11.908-8.5c-2.47-3.017-5.018-9.712-2.659-12.886a30.38,30.38,0,0,0-5.993,2.279S356,166.345,362.3,179.718Z",
    transform: "translate(-152.977 -81.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M362.948,120.756c-6.5,2.782-9.721,20.257-1.258,24.06S375.249,115.507,362.948,120.756Z",
    transform: "translate(-155.021 -103.059)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M394.957,135.888c-.535,13.2-.173,20.948-6.686,27.847-9.8,10.388-26.207,4.715-29.636-8.376-3.146-11.786-1.7-31.43,11.09-36.9a18.025,18.025,0,0,1,25.232,17.428Z",
    transform: "translate(-154.657 -104.912)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M369.463,132.307c0,1.069-.519,1.949-1.227,1.964s-1.29-.849-1.306-1.917.519-1.949,1.227-1.964S369.447,131.223,369.463,132.307Z",
    transform: "translate(-149.093 -97.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M361.743,132.467c0,1.069-.519,1.949-1.227,1.964s-1.29-.833-1.306-1.917.519-1.949,1.227-1.964S361.727,131.4,361.743,132.467Z",
    transform: "translate(-153.517 -97.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M365.089,132.06a38.493,38.493,0,0,1-4.939,9.288,6.187,6.187,0,0,0,5.144.849Z",
    transform: "translate(-152.978 -96.276)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M365.565,141.893h0a8.985,8.985,0,0,0,7.393-3.772.3.3,0,0,0-.11-.424.315.315,0,0,0-.425.094,8.528,8.528,0,0,1-6.874,3.473.314.314,0,0,0,.016.629Z",
    transform: "translate(-150.056 -93.08)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M372.733,130.351a.677.677,0,0,0,.393-.141.628.628,0,0,0,.094-.88,6.294,6.294,0,0,0-5.191-2.5.631.631,0,1,0,.11,1.257h0a5.067,5.067,0,0,1,4.09,2.012.614.614,0,0,0,.5.251Z",
    transform: "translate(-148.793 -99.265)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M357.593,130.843a.661.661,0,0,0,.582-.361,4.954,4.954,0,0,1,3.539-2.923.644.644,0,0,0,.535-.723.661.661,0,0,0-.724-.534,6.291,6.291,0,0,0-4.452,3.646.613.613,0,0,0,.3.833A.6.6,0,0,0,357.593,130.843Z",
    transform: "translate(-154.778 -99.569)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M405.782,167.5c2.973,4.275,5.584,8.455,8.274,12.761s5.175,8.643,7.645,13.044a249.477,249.477,0,0,1,13.339,27.58c.5,1.179.944,2.436,1.4,3.662l.692,1.854.346.943.409,1.289a28.437,28.437,0,0,1,1.07,10.451,39.642,39.642,0,0,1-5.993,17.287,68.476,68.476,0,0,1-10.24,12.792c-1.872,1.886-3.854,3.63-5.868,5.312a75.509,75.509,0,0,1-6.371,4.715l-6.4-7.669c1.4-1.572,2.989-3.52,4.4-5.327s2.8-3.74,4.106-5.626a68.2,68.2,0,0,0,6.528-11.535,25.861,25.861,0,0,0,2.407-10.749,12.452,12.452,0,0,0-.881-4.133l-1.258-2.8c-.488-1.037-.928-2.09-1.463-3.143-4.058-8.408-8.746-16.768-13.67-25.034s-10.083-16.564-15.2-24.5Z",
    transform: "translate(-136.411 -76.021)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M405.289,161.68c12.443,2.687,30.344,41.032,30.344,41.032L402.3,218.962a149.428,149.428,0,0,1-14.692-28.853C381.8,173.906,391.966,158.788,405.289,161.68Z",
    transform: "translate(-138.2 -79.551)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M483.677,228.109l33.49,98.833a15.492,15.492,0,0,1-9.674,19.581l-225.12,76.25a15.5,15.5,0,0,1-19.6-9.7l-33.475-98.8a14.979,14.979,0,0,1-.787-5.83,15.5,15.5,0,0,1,10.461-13.751l225.167-76.25A15.489,15.489,0,0,1,480.8,223a14.94,14.94,0,0,1,2.879,5.107Z",
    transform: "translate(-228.432 -47.367)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M483.677,228.109l33.49,98.833a15.492,15.492,0,0,1-9.674,19.581l-225.12,76.25a15.5,15.5,0,0,1-19.6-9.7l-33.475-98.8a14.979,14.979,0,0,1-.787-5.83,15.5,15.5,0,0,1,10.461-13.751l225.167-76.25A15.489,15.489,0,0,1,480.8,223a14.94,14.94,0,0,1,2.879,5.107Z",
    transform: "translate(-228.432 -47.367)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M480.753,222.99,387.612,306.2A46.654,46.654,0,0,1,353,317.91L228.45,308.48a15.5,15.5,0,0,1,10.461-13.751l225.167-76.25a15.489,15.489,0,0,1,16.674,4.51Z",
    transform: "translate(-228.45 -47.355)",
    fill: "#21d97d",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M405.965,232.52l-14.315.094,8.825,14.442s10.193-2.467,11.137-7.59Z",
    transform: "translate(-134.927 -38.86)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M385.96,241.051l7.85,11.614,9.926-5.642-8.825-14.442Z",
    transform: "translate(-138.188 -38.826)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M404.109,126.454c3.146,8.612-6.371,28.555-11.908,28.177s-7.047-21.106-3.9-26.26c-2.989,1.383-31.461,1.43-31.32-1.572.724-10.906,20.088-14.867,41.324-9.429C403.826,117.1,405.887,118.613,404.109,126.454Z",
    transform: "translate(-154.795 -106.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M389.949,141.354a12.426,12.426,0,0,1-7.708,5.7c-4.279,1.037-6.292-2.813-4.939-6.773,1.18-3.567,4.829-8.392,9.077-7.669S392.026,137.85,389.949,141.354Z",
    transform: "translate(-143.388 -95.999)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M346.594,119.9l65.345,7.543a1.258,1.258,0,0,0,1.384-1.1h0a1.257,1.257,0,0,0-1.085-1.383l-65.361-7.528a1.258,1.258,0,0,0-1.384,1.084h0A1.257,1.257,0,0,0,346.594,119.9Z",
    transform: "translate(-161.382 -104.64)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M406.323,130.93l1.133-9.743a4.276,4.276,0,0,0-3.933-4.212L363.394,109.4c-2.973-.566-5.71,1.1-5.694,3.457v12.478Z",
    transform: "translate(-154.382 -109.289)",
    fill: "#21d97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M360.08,119.487l16.989,1.964.582-4.95L360.1,114.49Z",
    transform: "translate(-153.019 -106.317)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 610,
    height: 610,
    transform: "translate(335 235)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSentArt);
export default __webpack_public_path__ + "static/media/link_sent_art.3854b00f2f5f3a4f450af9dae95df9d3.svg";
export { ForwardRef as ReactComponent };